import { ApplicationRef, enableProdMode } from '@angular/core';
import { enableDebugTools } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare global {
    interface Window {
        parentEmbedded: any;
        parentEmbeddedFiscoWeb: any;
    }
}

window.parentEmbedded = window.parentEmbedded || {};

if (environment.production) {
    enableProdMode();
}

Date.prototype.toJSON = function () {
    // eslint-disable-next-line no-invalid-this
    return this.toDateString();
};

const bootstrap = () =>
    platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .then((moduleRef) => {
            if (environment.isDebugTools) {
                // https://github.com/angular/angular/blob/master/docs/TOOLS.md
                const applicationRef = moduleRef.injector.get(ApplicationRef);
                const appComponent = applicationRef.components[0];
                enableDebugTools(appComponent);
            }
            return moduleRef;
        });
bootstrap().catch((err) => {
    throw new Error(err);
});
